import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import {translate} from "react-i18next";

import Step from './Step';
import { editProfileClick } from '../../../Modal/SettingsModal/ProfileSettings/actions';
import FloatingLabelInput from '../../../common/FloatingLabelInput';
import FloatingLabelSelect from '../../../common/FloatingLabelSelect';

@translate(['register'], {wait:true})
class ProfileStep extends Step {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      firstName: '',
      middleName: '',
      lastName: '',
      birthDate: '',
      drivingLicenceDate: '',
      drivingExp: '',
      birthYear: '',
      isNew: props.profileIsNew
    };
  }

  handleBackClick(e) {
    e.preventDefault();
    this.props.decreaseStepIndex()
  }

  handleNextClick(e) {
    e.preventDefault();
    this.props.increaseStepIndex()
    this.props.handleSaveClick(this.state);
  }

  createRange = (start, end) => Array.from({length: (end - start)}, (v, k) => k + start)

  getLet = (year) => {
    const { t, currentLanguage } = this.props
    let suffix = t('register:years')
    if (currentLanguage != 'ru')
      return suffix

    if( year == 1 || ( year > 20 && year % 10 == 1))
      suffix = "год"
    if (( year > 1 && year < 5 )|| (year > 20 && year % 10 > 1 &&  year % 10 < 5) )
      suffix = "года"
    return suffix
  }

  handleLastName = (e) => {
    const { t } = this.props
    this.setState({
      lastName: e.target.value,
      lastNameError: e.target.value.length > 0 && e.target.value.length < 2 ? t('register:length_error') : ''
    });
  }

  handleFirstName = (e) => {
    const { t } = this.props
    this.setState({
      firstName: e.target.value,
      firstNameError: e.target.value.length > 0 && e.target.value.length < 2 ? t('register:length_error') : ''
    });
  }

  handleMiddleName = (e) => {
    const { t } = this.props
    this.setState({
      middleName: e.target.value,
      middleNameError: e.target.value.length > 0 && e.target.value.length < 2 ? t('register:length_error') : ''
    });
  }

  handleBirthYear = (e) => {
    const { t } = this.props
    const year = parseInt(e.target.value)
    this.setState({
      birthYear: year,
      birthDate: { year: year, month: 1, day: 1 }
    });
  }

  handleDrivingExp = (e) => {
    const { t } = this.props
    const birthYear = this.state.birthYear ? parseInt(this.state.birthYear) : null
    const currentYear = new Date().getFullYear()
    const drivingExp = parseInt(e.target.value)
    const isCorrect = birthYear == null || (currentYear - drivingExp) >= parseInt(birthYear) + 17
    const drivingLicenceDate = new Date(currentYear - drivingExp, 1, 1)
    this.setState({
      drivingExp: e.target.value,
      drivingExpError: isCorrect ? '' : t('register:drivingExpError') + ` ${birthYear} - ${currentYear - (parseInt(birthYear) + 17)}`,
      drivingLicenceDate: { year: drivingLicenceDate.getFullYear(), month: drivingLicenceDate.getMonth() + 1, day: drivingLicenceDate.getDate() },
    });
  }

  validEmail = (email) => {
    const regex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return regex.test(String(email).toLowerCase());
  }

  handleEmail = (e) => {
    const { t } = this.props
    this.setState({
      email: e.target.value,
      emailError: this.validEmail(e.target.value) ? '' : t('register:email_error')
    });
  }

  render() {
    const currentYear = new Date().getFullYear()
    const startYear = currentYear - 55
    let years = this.createRange(startYear, currentYear).map((year) =>
      <option value={year} >{year}</option>
    ).reverse();

    years.unshift(
      <option></option>
    )

    let exp = this.createRange(1, 50).map((year) =>
      <option value={year} >{year} {this.getLet(year)}</option>
    )
    exp.unshift(
      <option></option>
    )


    const { t } = this.props
    const { lastName, firstName, middleName,
            birthYear, drivingExp, email,
            lastNameError, firstNameError, middleNameError,
            birthYearError, drivingExpError, emailError } = this.state


    return (
      <div className="container">
        {/* <a onClick={this.handleBackClick} className="backStep" href=""></a> */}
        <form className="popupForm popupRegistrationForm" action="#">
          <div className="stepTitle">
            <h2>{t('register:personal')}</h2>
          </div>
          <div className="popupForm__body">
            <div className="row">
              <FloatingLabelInput error={lastNameError} type="text" label={t('register:lastname')} defaultValue={lastName} onChange={this.handleLastName}/>
            </div>
            <div className="row">
              <FloatingLabelInput error={firstNameError} type="text" label={t('register:firstname')} defaultValue={firstName} onChange={this.handleFirstName}/>
            </div>
            <div className="row">
              <FloatingLabelInput error={middleNameError} type="text" label={t('register:middlename')} defaultValue={middleName} onChange={this.handleMiddleName}/>
            </div>
            <div className="row">
              <div className="float-left halfsize padding-right-24">
                <FloatingLabelSelect error={birthYearError} type="text" label={t('register:birthDate')} defaultValue={birthYear} onChange={this.handleBirthYear}>
                  {years}
                </FloatingLabelSelect>
              </div>
              <div className="float-right halfsize">
                <FloatingLabelSelect error={drivingExpError} type="text" label={t('register:drivingExp')} defaultValue={drivingExp} onChange={this.handleDrivingExp}>
                  {exp}
                </FloatingLabelSelect>
              </div>
            </div>
            <div className="row">
              <FloatingLabelInput error={emailError} type="text" label={t('register:email')} defaultValue={email} onChange={this.handleEmail}/>
            </div>
          </div>
          <div className="rowButton">
            <button
            onClick={(e) => {
              e.preventDefault();
              this.handleNextClick(e);
              this.setState({isFormSubmitted: true});
            }} className="btn"><span>{t('register:continue')}</span></button>
          </div>
        </form>
      </div>
    );
  }
}

ProfileStep.propTypes = {
  handleSaveClick: PropTypes.func,
  errors: PropTypes.array,
};

export default connect(
  (state) => {
    return {
      errors: state.settings.profileErrors,
      currentLanguage: state.langs.currentLanguage
    };
  },
  (dispatch) => {
    return {
      handleSaveClick(profile) {
        return dispatch(editProfileClick({
          profile: {
            ...profile,
          },
        }));
      },
    };
  },
)(ProfileStep);



// WEBPACK FOOTER //
// ./src/components/Auth/Registration/Steps/ProfileStep.js